import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const FavouriteIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path d="M12 17.4L16.1 19.8C16.9 20.2 17.8 19.6 17.6 18.7L16.5 14.1L20.1 11C20.8 10.4 20.4 9.4 19.5 9.3L14.8 9L12.9 4.6C12.6 3.8 11.4 3.8 11.1 4.6L9.20001 9L4.40001 9.4C3.50001 9.5 3.20001 10.5 3.80001 11.1L7.40001 14.2L6.30001 18.8C6.10001 19.6 7.00001 20.3 7.80001 19.9L12 17.4Z" />
    </Icon>
  );
};
